"use client";
import {
  useFormControl
} from "../__chunks/GSOIM56U.js";
import "../__chunks/F53GGRQB.js";
import "../__chunks/RZ4GPYOB.js";
import "../__chunks/VDHZ5F7K.js";
import {
  createElement,
  createHook,
  forwardRef,
  memo
} from "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/form/form-field.tsx
var TagName = "input";
var useFormField = createHook(
  function useFormField2(props) {
    return useFormControl(props);
  }
);
var FormField = memo(
  forwardRef(function FormField2(props) {
    const htmlProps = useFormField(props);
    return createElement(TagName, htmlProps);
  })
);
export {
  FormField,
  useFormField
};
